var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-add",on:{"click":function($event){return _vm.$emit('add')}}},[_c('img',{attrs:{"src":require("assets/icons/add.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }